import { FC } from "react";
import { observer } from "mobx-react";
import { AttachmentQuestion, InterimBalanceSheetForm } from "./interimBalanceSheetDomain";
import { DateQuestion } from "@/dbot/common/commonComponents";
import { VBox } from "@/components-v2/Box";
import { Alert } from "@/components-v2/Alert";
import { UploadFilesPanel } from "@/components-v2/UploadFilesPanel";
import { AttachmentListItem, UploadingAttachmentListItem } from "@/components-v2/AttachmentsPanel";
import { useTranslation } from "@/stores/RootStoreContext";

const AttachmentQuestionView: FC<{ title: string; question: AttachmentQuestion }> = observer(
  ({ title, question }) => (
    <VBox gap={"sm"}>
      <div>{title}</div>
      {question.attachment && (
        <AttachmentListItem
          attachment={question.attachment}
          isDeleting={question.isDeleting}
          onOpen={question.onOpen}
          onDelete={question.onDelete}
        />
      )}
      {question.uploads.map((upload) => (
        <UploadingAttachmentListItem key={upload.id} upload={upload} />
      ))}
      {question.dropzone && <UploadFilesPanel {...question.dropzone} />}
    </VBox>
  ),
);

export const InterimBalanceSheetView: FC<{ form: InterimBalanceSheetForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();

    return (
      <VBox gap={"md"}>
        <AttachmentQuestionView
          title={t("decisions.interimBalanceSheet.balanceSheetUpload.title")}
          question={form.balanceSheet}
        />
        {form.balanceSheetValidationError && (
          <Alert type={"error"} message={<>{t(form.balanceSheetValidationError)}</>} />
        )}
        <DateQuestion
          question={t("decisions.interimBalanceSheet.balanceSheetDate.questionText")}
          infoText={t("decisions.interimBalanceSheet.balanceSheetDate.helperText")}
          field={form.balanceSheetDate}
          isLocked={form.isProjectLocked}
        />
        {form.hasAuditor && (
          <AttachmentQuestionView
            title={t("decisions.interimBalanceSheet.auditorConfirmationUpload.title")}
            question={form.auditorConfirmation}
          />
        )}
      </VBox>
    );
  },
);
